import Route from '@ember/routing/route';

export default class SchoolNotFoundRoute extends Route {}
